<template>
  <div
    class="icons-view-page"
    style="padding: 16px;">
    <div
      v-if="env === 'development'"
      style="font-size: 12px;">

      <br>Archive Icons:
      <div style="display: flex;">
        <ul>
          <li>NOTARIZED notarized-backup-clr <el-icon :name="'stub' | archiveIcon('NOTARIZED')"/></li>
          <li>BACKUP folder-backup-clr <el-icon :name="'stub' | archiveIcon('BACKUP')"/></li>
          <li>A3_BACKUP folder-backup-clr <el-icon :name="'stub' | archiveIcon('A3_BACKUP')"/></li>
          <li>ARPF_BACKUP folder-backup-clr <el-icon :name="'stub' | archiveIcon('ARPF_BACKUP')"/></li>
          <li>DISK_BACKUP disk-backup-clr <el-icon :name="'stub' | archiveIcon('DISK_BACKUP')"/></li>
          <li>A3_DISK_BACKUP disk-backup-clr <el-icon :name="'stub' | archiveIcon('A3_DISK_BACKUP')"/></li>
          <li>ENTIRE_PC pc-clr <el-icon :name="'stub' | archiveIcon('ENTIRE_PC')"/></li>
          <li>A3_ENTIRE_PC_BACKUP pc-clr <el-icon :name="'stub' | archiveIcon('A3_ENTIRE_PC_BACKUP')"/></li>
          <li>SYNC sync-clr <el-icon :name="'stub' | archiveIcon('SYNC')"/></li>
          <li>ARCHIVING archive-section-clr <el-icon :name="'stub' | archiveIcon('ARCHIVING')"/></li>
        </ul>
        <ul>
          <li>FILE folder-backup-clr <el-icon :name="'stub' | archiveIcon('FILE')"/></li>
          <li>IMAGE disk-backup-clr <el-icon :name="'stub' | archiveIcon('IMAGE')"/></li>
          <li>EXCHANGE db-clr <el-icon :name="'stub' | archiveIcon('EXCHANGE')"/></li>
          <li>SQL server-clr <el-icon :name="'stub' | archiveIcon('SQL')"/></li>
          <li>SYS_STATE system-state-clr <el-icon :name="'stub' | archiveIcon('SYS_STATE')"/></li>
          <li>EXCHANGE_DOC mailbox-clr <el-icon :name="'stub' | archiveIcon('EXCHANGE_DOC')"/></li>
          <li>EXCHANGE_UNKNOWN folder-backup-clr <el-icon :name="'stub' | archiveIcon('EXCHANGE_UNKNOWN')"/></li>
          <li>VSS_APPLICATION folder-backup-clr <el-icon :name="'stub' | archiveIcon('VSS_APPLICATION')"/></li>
          <li>APPLICATION folder-backup-clr <el-icon :name="'stub' | archiveIcon('APPLICATION')"/></li>
          <li>UNDEFINED folder-backup-clr <el-icon :name="'stub' | archiveIcon('UNDEFINED_TYPE')"/></li>
        </ul>
      </div>

      <el-divider/>

      <br>File Icons:
      <div style="display: flex;">
        <ul>
          <li>0 image-clr <el-icon :name="'file1.bmp' | fileIcon"/></li>
          <li>1 vector-clr <el-icon :name="'file1.ai' | fileIcon"/></li>
          <li>2 graph-clr <el-icon :name="'file1.ps' | fileIcon"/></li>
          <li>3 music-clr <el-icon :name="'file1.aif' | fileIcon"/></li>
          <li>4 video-clr <el-icon :name="'file1.3g2' | fileIcon"/></li>
          <li>5 pdf-clr <el-icon :name="'file1.pdp' | fileIcon"/></li>
          <li>6 presentation-clr <el-icon :name="'file1.odp' | fileIcon"/></li>
          <li>7 ppt-clr <el-icon :name="'file1.pot' | fileIcon"/></li>
          <li>8 spreadsheet-clr <el-icon :name="'file1.ods' | fileIcon"/></li>
          <li>9 xls-clr <el-icon :name="'file1.xls' | fileIcon"/></li>
          <li>10 text-clr <el-icon :name="'file1.tex' | fileIcon"/></li>
        </ul>
        <ul>
          <li>11 doc-clr <el-icon :name="'file1.doc' | fileIcon"/></li>
          <li>12 archive-clr <el-icon :name="'file1.7z' | fileIcon"/></li>
          <li>13 web-clr <el-icon :name="'file1.asp' | fileIcon"/></li>
          <li>14 programming-clr <el-icon :name="'file1.cpp' | fileIcon"/></li>
          <li>15 sys-clr <el-icon :name="'file1.cab' | fileIcon"/></li>
          <li>16 exe-clr <el-icon :name="'file1.cgi' | fileIcon"/></li>
          <li>17 disk-media-clr <el-icon :name="'file1.toast' | fileIcon"/></li>
          <li>18 db-clr <el-icon :name="'file1.log' | fileIcon"/></li>
          <li>19 font-clr <el-icon :name="'file1.fnt' | fileIcon"/></li>

          <li>FOLDER folder-clr <el-icon :name="'folder' | fileIcon('folder')"/></li>
          <li>VOLUME hard-drive-clr <el-icon :name="'volume' | fileIcon('volume')"/></li>
          <li>UNDEFINED unknown-clr <el-icon :name="'UNDEFINED' | fileIcon"/></li>
        </ul>
      </div>

      <el-divider/>

      <br>Other multicolor svg icons:
      <div style="display: flex;">
        <ul>
          <li>clr-pc-clr--32 <el-icon name="clr-pc-clr--32"/></li>
          <li>clr-devices-clr--32 <el-icon name="clr-devices-clr--32"/></li>
          <li>clr-time-clr--16 <el-icon name="clr-time-clr--16"/></li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'IconsViewPage',
  data: () => ({
    env: process.env.NODE_ENV
  })
};
</script>
